<template>
  <section>
    <div class="tip" style="margin:0 0 0 20px">* 合同基本资料</div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="合同编号">
          <el-input size="small" :disabled="true" placeholder="请输入合同编号" v-model="contract.htbh"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <el-form-item label="合同需求单位">
      <el-input size="small" :disabled="true" v-model="contract.departmentVO.name"></el-input>
    </el-form-item>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="合同负责人">
          <el-input size="small" :disabled="true" v-model="contract.leader.name"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系方式">
          <el-input size="small" :disabled="true" v-model="contract.leader.mobile"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="合同名称">
          <el-input size="small" v-model="contract.name" :disabled="true" placeholder="请输入合同名称"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="验收时间">
          <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="form.yssj" type="date" placeholder="选择验收时间">
          </el-date-picker>
        </el-form-item>
      </el-col>
    </div>
    <el-form-item label="验收情况说明">
      <el-input type="textarea" placeholder="请输入合同验收情况说明" :autosize="{ minRows: 3, maxRows: 6}" size="small" v-model="form.ysqksm"></el-input>
    </el-form-item>
  </section>
</template>

<script>
  export default {
    props: ['contract', 'formByFather', 'userData'],
    data() {
      return {
        form: {},
      }
    },
    mounted() {
      this.form = this.formByFather
    },
    methods: {
      getFromData() {
        return this.form
      }
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/createContractEnd.vue